// extracted by mini-css-extract-plugin
export default {"stack":"bJl2Nh"};